import React from "react";
import { useDispatch } from "react-redux";
import { ModalComponent } from "..";
import { PureLoginForm } from ".";
import { loginModal } from "../../state/action";


const LoginModal = ({show}) => {
  const dispatch = useDispatch();
  return (
    <ModalComponent width={600} visible={show} onCancel={() => dispatch(loginModal())}>
      <div className="px-2 md:px-16">
        <PureLoginForm />
      </div>
    </ModalComponent>
  );
};

export default LoginModal;
